module.exports = __webpack_public_path__ + "static/media/instagram.fff88925.svg";